<div class="form-row">
	<div class="form-group mod-quarter mb-0" [ngClass]="{ 'has-error': error }">
		<label for="phonecode">{{ "phonecode" | translate }}</label>
		<bp-select
			id="phonecode"
			class="verification-select"
			[countrySelection]="true"
			[options]="phoneCodeOptions"
			[(selectedValue)]="phoneCode"
			[disabled]="disabled"
			[searchable]="true"
			[clearable]="false"
			[searchTermOnClose]="selectedCountryName()"
			[bindLabel]="'name'">
		</bp-select>
		<div class="text-small-gray mt-5 text-full-word-break mb-10">
			{{ "verification_phone_explanation_text" | translate }}
		</div>
	</div>
	<bp-input
		[type]="'tel'"
		class="form-group mod-three-quarter mb-0"
		[formatted-output]="true"
		iconLeading="disabled"
		(valueChange)="onPhoneNumberChange($event); model.dirty = true"
		[placeholder]="'000-000-000-00'"
		icon="{{ disabled ? 'bpi__icon-lock' : '' }}"
		[label]="'mobilenumber' | translate"
		[(model)]="model"
		[error]="model.getValidationError(field) | translate"
		field="phonenumber"></bp-input>
</div>
